import { Button } from "@/components/ui/button";
import {
    ArrowRight,
    ShoppingCart,
    Download,
    ExternalLink,
    Check,
    Phone
} from "lucide-react";

const iconMap: Record<string, any> = {
    arrow: ArrowRight,
    cart: ShoppingCart,
    download: Download,
    external: ExternalLink,
    check: Check,
    none: null,
};

export const StaticButtonPreview = ({ settings }: any) => {
    const Icon = settings.icon && settings.icon !== "none" ? iconMap[settings.icon] : null;
    const iconPosition = settings.iconPosition || "right";

    return (
        <div className="flex justify-center p-4">
            <Button
                style={{
                    backgroundColor: settings.backgroundColor || "#000000",
                    color: settings.color || "#ffffff",
                    fontSize: `${settings.fontSize || 16}px`,
                    padding: settings.padding || "12px 24px",
                    borderRadius: `${settings.borderRadius || 8}px`,
                    width: settings.width || "auto",
                }}
                className="gap-2"
            >
                {Icon && iconPosition === "left" && <Icon className="w-4 h-4" />}
                {settings.text || "اضغط هنا"}
                {Icon && iconPosition === "right" && <Icon className="w-4 h-4" />}
            </Button>
        </div>
    );
};

export const WhatsAppButtonPreview = ({ settings }: any) => {
    const isFloating = settings.displayType === "floating";

    if (isFloating) {
        const positionClasses: Record<string, string> = {
            "bottom-right": "bottom-6 right-6",
            "bottom-left": "bottom-6 left-6",
            "top-right": "top-6 right-6",
            "top-left": "top-6 left-6",
        };

        return (
            <div className="relative h-32 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-center">
                <span className="text-sm text-gray-500">زر واتساب عائم (سيظهر في الزاوية)</span>
                <button
                    className={`fixed ${positionClasses[settings.floatingPosition || "bottom-right"]} z-50 w-14 h-14 rounded-full shadow-2xl flex items-center justify-center transition-transform hover:scale-110`}
                    style={{
                        backgroundColor: settings.backgroundColor || "#25D366",
                    }}
                >
                    <Phone className="w-6 h-6 text-white" />
                </button>
            </div>
        );
    }

    // Inline button
    return (
        <div className="flex justify-center p-4">
            <Button
                className="gap-2"
                style={{
                    backgroundColor: settings.backgroundColor || "#25D366",
                    color: settings.color || "#ffffff",
                    fontSize: `${settings.fontSize || 16}px`,
                    padding: settings.padding || "12px 24px",
                    borderRadius: `${settings.borderRadius || 8}px`,
                }}
            >
                <Phone className="w-4 h-4" />
                {settings.buttonText || "تواصل معنا"}
            </Button>
        </div>
    );
};
